import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import profileImg from "../../assets/images/profile-img.png";
import logoIcon from "../../assets/images/logo-icon.png";

/**
 * Shared frame for the SPA auth pages (login, cadastro, confirmação, senha).
 * Follows the Skote "auth" card: soft-primary header with illustration,
 * round logo badge, form body, small footer.
 */
const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="account-pages my-5 pt-sm-5">
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={5}>
          <Card className="overflow-hidden">
            <div className="bg-primary-subtle">
              <Row>
                <Col xs={7}>
                  <div className="text-primary p-4">
                    <h5 className="text-primary">{title}</h5>
                    {subtitle && <p className="mb-0">{subtitle}</p>}
                  </div>
                </Col>
                <Col xs={5} className="align-self-end">
                  <img src={profileImg} alt="" className="img-fluid" />
                </Col>
              </Row>
            </div>
            <CardBody className="pt-0">
              <div className="auth-logo">
                <Link to="/" className="auth-logo-light">
                  <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img src={logoIcon} alt="ACIG" className="rounded-circle" height="34" />
                    </span>
                  </div>
                </Link>
                <Link to="/" className="auth-logo-dark">
                  <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img src={logoIcon} alt="ACIG" className="rounded-circle" height="34" />
                    </span>
                  </div>
                </Link>
              </div>
              <div className="p-2">{children}</div>
            </CardBody>
          </Card>
          {footer && <div className="mt-4 text-center">{footer}</div>}
          <div className="mt-3 text-center text-muted small">
            © {new Date().getFullYear()} ACIG Guapiaçu Cidadão
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

AuthLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

export default AuthLayout;
